export default "__VITE_ASSET__C04sXizA__"